import React from 'react';
import {
  Grid,
  InputAdornment,
  Input,
  FormControl,
  InputLabel,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { Filter } from '@carbon/icons-react';


import useStore from '../../store/useStore';

const SearchBarEvents = () => {
  const {
    setFilter,
    filters: { searchEvent },
  } = useStore((state: any) => ({
    setFilter: state.setFilter,
    filters: state.filters,
  }));

  const toggleFilters = () => {
    const targetDiv = document.getElementById("FilterBarEvents");
    const btn = document.getElementById("toggleFiltersButtonEvents");

    if (targetDiv!.style.display !== "none") {
      targetDiv!.style.display = "none";
      btn!.style.fontWeight = "bold";
      //btn!.style.color = "white";
    } else {
      targetDiv!.style.display = "block";
      btn!.style.fontWeight = "normal";
      //btn!.style.color = "#007FAD";
    }
  }



  return (
    <div style={{ width: '100%', padding: '1.5rem 0 1rem 0', backgroundColor: "#293336", margin: "0px", paddingRight: "10px" }}>
      <div className='ituContainer grid'>
        <div data-span="6" >
        <FormControl variant="standard" fullWidth style={{ backgroundColor: '#182124', borderRadius: "4px" }}>
          <InputLabel htmlFor="search"></InputLabel>
          <Input
            id="searchEvent"
            style={{ fontSize: '1rem', color: "#fff", margin: "0px", height: "50px" }}
            placeholder="Search"
            value={searchEvent}
            onChange={(e) => setFilter('searchEvent', e.target.value)}
            startAdornment={
              <InputAdornment position="start">
                <FontAwesomeIcon icon={faSearch} style={{ margin: '0 1rem', color: "#fff" }} />
              </InputAdornment>
            }
          />
          </FormControl>
          </div>
          <div data-span="2" style={{ verticalAlign: 'middle', fontWeight: 'bold', textAlign: 'center', display: 'flex', alignItems: 'center', color:'white' }}>
          <div id='toggleFiltersButtonEvents'

           
            onClick={toggleFilters}
          >
            <Filter style={{ marginRight: '5px' }} />
            Filters
          </div>

        </div>      </div>
    </div>
  );
};
export default SearchBarEvents;
